import React, { Component } from "react";
import PropTypes from "prop-types";
import { Banner } from "../home/banner/index.jsx";
import { EditionCard } from "./card.jsx";
import "./index.scss";
export class PastEditions extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const event = this.props.config;
    document.title = "".concat(event.name, " ").concat(event.location);
  }

  render() {
    const event = this.props.config;

    const renderEditions = () => {
      const editions = event.editions;
      const pastEditions = editions.filter(edition => edition.endTime < new Date().valueOf());
      return /*#__PURE__*/React.createElement("div", {
        id: "editions",
        className: "recentEditions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "banner"
      }, "All Editions (".concat(pastEditions.length, ")")), /*#__PURE__*/React.createElement("div", {
        className: "editions"
      }, pastEditions.map(edition => {
        return /*#__PURE__*/React.createElement(EditionCard, {
          key: edition.id,
          edition: edition
        });
      })));
    };

    return /*#__PURE__*/React.createElement("div", {
      id: "event-home",
      className: "event-home"
    }, /*#__PURE__*/React.createElement(Banner, {
      event: event,
      small: true
    }), renderEditions(), /*#__PURE__*/React.createElement("p", {
      className: "copyright"
    }, "\xA9 2021 Thoughtworks, Inc."));
  }

}
PastEditions.propTypes = {
  config: PropTypes.object.isRequired
};